// captionBarColors.js — PURE colour resolution for the image caption bar
// (ImageBlock's showImageTitle strip, shared by Image, Image With Text and Image
// Grid, in both Edit Wheel and View Wheel).
//
// T22.138 (Terry via Gordon, 2026-10-12, Staging /builder): the caption bar was a
// hardcoded dark slate (#344054) whatever the block or segment colour. RULE
// (Gordon): caption background = the block BORDER colour, even when the border is
// switched off (width 0); with no border colour, the SEGMENT colour. The caption
// text is auto light/dark for WCAG AA (>= 4.5:1) on that background — black/white
// guarantees >= ~4.58:1 for any solid fill (see utils/contrast BLACK_TEXT).
//
// No React, no Redux: callers pass already palette-resolved hex values.

import {
  autoTextColor,
  effectiveBgHex,
  BLACK_TEXT,
  WHITE_TEXT,
} from "../../../../utils/contrast";

/** Last resort when neither a border nor a segment colour resolves. */
export const CAPTION_BAR_FALLBACK_BG = "#344054";

/**
 * @param {{ borderColor?: string|null, segmentColor?: string|null }} colors
 * @returns {{ backgroundColor: string, color: string }}
 */
export function resolveCaptionBarColors({ borderColor, segmentColor } = {}) {
  const backgroundColor =
    effectiveBgHex(borderColor) ||
    effectiveBgHex(segmentColor) ||
    CAPTION_BAR_FALLBACK_BG;
  const color = autoTextColor(backgroundColor, {
    dark: BLACK_TEXT,
    light: WHITE_TEXT,
    fallback: WHITE_TEXT,
  });
  return { backgroundColor, color };
}
